import { filter, join, map, split, trim, uniq } from 'lodash'

export default {
  methods: {
    getClientCountries (client) {
      return join(map(split(client.country_iso_3, ','), iso => this.translateIsoCountry(trim(iso))), ', ')
    },
    getCountCountries (region) {
      return uniq(map(filter(this.$store.state.players.regions, ['region_id', region]), 'country')).length
    },
    getPlayerImage (id) {
      try {
        return require(`@/assets/powerplayers/${id}.png`)
      } catch (_) {
        return require('@/assets/default.jpg')
      }
    },
    getFullUrl (page) {
      return window.location.origin + window.location.pathname + page.toString()
    },
    translateRegion (region) {
      return this.$te(`regions.${region}`) ? this.$t(`regions.${region}`) : region
    },
    regionDescription (region) {
      let desc = this.$te(`regions_desc.${region}`) ? this.$t(`regions_desc.${region}`) : region
      
      const count = this.getCountCountries(region)
      
      desc.replace("[count_countries]", count)

      return desc
    },
    translateIsoCountry (iso) {
      return this.$te(`country.${iso.toLowerCase()}`) ? this.$t(`country.${iso.toLowerCase()}`) : iso.toLowerCase()
    },
    translateProvider (provider) {
      return this.$te(`providers.${provider}`) ? this.$t(`providers.${provider}`) : provider
    },
    providerDesc(provider) {
      return this.$te(`providers_desc.${provider}`) ? this.$t(`providers_desc.${provider}`) : provider
    }
  }
}
